import { render, staticRenderFns } from "./CourseCategoryManage.vue?vue&type=template&id=01c303f3&scoped=true"
import script from "./CourseCategoryManage.vue?vue&type=script&lang=js"
export * from "./CourseCategoryManage.vue?vue&type=script&lang=js"
import style0 from "./CourseCategoryManage.vue?vue&type=style&index=0&id=01c303f3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c303f3",
  null
  
)

export default component.exports